module.exports = __webpack_public_path__ + "Roboto-Thin.90d3804f0231704c15cc.woff";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-Thin.woff
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Thin.woff
// module chunks = styles